<template>
  <div class="scanner-container">
    <!-- 顶部导航栏 -->
    <div class="scanner-header">
      <div class="header-content">
        <el-icon class="back-btn" @click="goBack">
          <ArrowLeft />
        </el-icon>
        <h2 class="header-title">扫码识别</h2>
        <div class="header-actions">
          <el-icon class="flash-btn" @click="toggleFlash" :class="{ active: isFlashOn }">
            <Lightning />
          </el-icon>
        </div>
      </div>
    </div>

    <!-- 视频流容器 -->
    <video ref="video" class="scanner-video" autoplay playsinline webkit-playsinline></video>

    <!-- 扫码框UI -->
    <div class="scan-frame">
      <div class="corner top-left"></div>
      <div class="corner top-right"></div>
      <div class="corner bottom-left"></div>
      <div class="corner bottom-right"></div>
      
      <!-- 扫描线动画 -->
      <div class="scan-line"></div>
      
      <!-- 扫描提示 -->
      <div class="scan-tips">
        <p class="tip-text">将条形码/二维码放入框内</p>
        <p class="tip-subtext">自动识别并返回结果</p>
      </div>
    </div>

    <!-- 底部状态显示 -->
    <div class="scanner-footer">
      <div class="footer-content">
        <div class="status-indicator" :class="{ scanning: isScanning }">
          <div class="status-dot"></div>
          <span class="status-text">{{ isScanning ? '扫描中...' : '准备就绪' }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { BrowserMultiFormatReader } from '@zxing/library';
import {ElMessage, ElIcon} from "element-plus";
export default {
  components: {
    ElIcon,
  },
  data() {
    return {
      codeReader: null,
      result: null,
      isScanning: false,
      selectedDeviceId: null,
      isFlashOn: false, // 控制闪光灯状态
    };
  },
  mounted() {
    this.startScan();
  },
  methods: {
    async startScan() {
      this.isScanning = true;
      this.result = null;
      this.codeReader = new BrowserMultiFormatReader();

      try {

        // 1. 先获取权限（触发用户授权）
        const stream = await navigator.mediaDevices.getUserMedia({ video: true });
        stream.getTracks().forEach(track => track.stop());

        // 获取可用摄像头设备
        // 2. 枚举设备
        const devices = await navigator.mediaDevices.enumerateDevices();
        const videoDevices = devices.filter(d => d.kind === 'videoinput');

        // 3. 设备选择逻辑
        if(videoDevices.length === 0) throw new Error('未检测到摄像头设备');

        const backDevice = videoDevices.find(d =>
            d.label.includes('back') || d.label.includes('rear')
        );

        this.selectedDeviceId = backDevice?.deviceId || videoDevices.deviceId;

        // 启动扫描
        this.codeReader.decodeFromVideoDevice(
            this.selectedDeviceId,
            this.$refs.video,
            (result, error) => {
              if (result) {
                this.result = result.text;
                this.stopScan();
                this.$router.push({
                  path: '/mobile',
                  query: {trackNumber:this.result, autoSearch: 'true'},
                });
              }
              if (error && !(error instanceof DOMException)) {
                console.error('扫描错误:', error);
                //ElMessage.error(`扫描错误: ${error.message}`);
              }
            }
        );
      } catch (error) {
        console.error('摄像头初始化失败:', error);
        ElMessage.error(`错误: ${error.message || '请检查摄像头权限'}`);
        this.stopScan();
      }
    },
    stopScan() {
      this.codeReader?.reset();
      this.isScanning = false;
    },
    toggleFlash() {
      this.isFlashOn = !this.isFlashOn;
      // 实际的闪光灯控制需要通过浏览器API，这里仅更新状态
      // 例如：this.$refs.video.srcObject.getTracks()[0].applyConstraints({ facingMode: this.isFlashOn ? 'environment' : 'user' });
    },
    goBack() {
      this.$router.go(-1);
    }
  },
  unmounted() {
    this.stopScan();
  }
};
</script>

<style scoped>
.scanner-container {
  position: relative;
  width: 100%;
  height: 100vh;
  overflow: hidden;
  background: #000;
}

.scanner-header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 60px;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  padding: 0 20px;
  z-index: 10;
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.header-title {
  color: #fff;
  font-size: 20px;
  margin: 0 20px;
}

.header-actions .el-icon {
  color: #fff;
  font-size: 24px;
  cursor: pointer;
  transition: transform 0.3s ease;
}

.header-actions .el-icon:hover {
  transform: scale(1.1);
}

.header-actions .el-icon.active {
  color: #ffd700; /* 闪光灯激活时的颜色 */
}

.scanner-video {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.scan-frame {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 280px;
  height: 280px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  border-radius: 12px;
  background: rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(10px);
}

.corner {
  position: absolute;
  width: 40px;
  height: 40px;
  border-color: #00ff00;
  border-style: solid;
  border-width: 0;
  box-shadow: 0 0 10px rgba(0, 255, 0, 0.5);
}

/* 扫码框四角样式 */
.top-left {
  top: 0;
  left: 0;
  border-top-width: 5px;
  border-left-width: 5px;
}
.top-right {
  top: 0;
  right: 0;
  border-top-width: 5px;
  border-right-width: 5px;
}
.bottom-left {
  bottom: 0;
  left: 0;
  border-bottom-width: 5px;
  border-left-width: 5px;
}
.bottom-right {
  bottom: 0;
  right: 0;
  border-bottom-width: 5px;
  border-right-width: 5px;
}

.scan-line {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 2px;
  background: linear-gradient(90deg, transparent, #00ff00, transparent);
  animation: scanLine 2s infinite linear;
  box-shadow: 0 0 10px #00ff00;
}

@keyframes scanLine {
  0% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(calc(100% - 2px));
  }
}

.scan-tips {
  position: absolute;
  bottom: 20px;
  text-align: center;
  color: #fff;
  font-size: 14px;
  z-index: 1;
}

.scan-tips .tip-text {
  margin-bottom: 5px;
}

.scanner-footer {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 60px;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  padding: 0 20px;
  z-index: 10;
}

.footer-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.status-indicator {
  display: flex;
  align-items: center;
  color: #fff;
  font-size: 14px;
}

.status-indicator .status-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: #00ff00;
  margin-right: 8px;
}

.status-indicator.scanning .status-dot {
  background-color: #ff0000; /* 扫描中时变为红色 */
}



/* 响应式设计 */
@media (max-width: 768px) {
  .scan-frame {
    width: 250px;
    height: 250px;
  }
  
  .header-title {
    font-size: 18px;
  }
  
  .scan-tips .tip-text {
    font-size: 12px;
  }
  
  .scan-tips .tip-subtext {
    font-size: 10px;
  }
  
  .status-text {
    font-size: 12px;
  }
}
</style>
